<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import type { HtmlTargetType } from '~/types/elementsUi'

type BaseLinkProps = {
  label?: string
  target?: HtmlTargetType
  srLabel?: string
}

type InternalLink = {
  to: RouteLocationRaw
  href?: never
  download?: never
}

type FileLink = {
  href: string
  download: string | boolean
  to?: never
}

type ExternalLink = {
  href: string
  download?: never
  to?: never
}

type VLinkProps = BaseLinkProps & (InternalLink | FileLink | ExternalLink)

const props = defineProps<VLinkProps>()

const { t, te } = useI18n()

const isInternal = computed(() => 'to' in props && props.to)
const isFile = computed(() => 'download' in props && props.download)

const computedLabel = computed(() =>
  props.label && te(props.label) ? t(props.label) : props.label
)

const computedSrLabel = computed(() =>
  props.srLabel && te(props.srLabel) ? t(props.srLabel) : props.srLabel
)
</script>

<template>
  <NuxtLink v-if="isInternal" :to :target>
    <span v-if="computedSrLabel" class="sr-only">{{ computedSrLabel }}</span>
    <slot>
      {{ computedLabel }}
    </slot>
  </NuxtLink>

  <a
    v-else
    :href
    :target
    :rel="target === '_blank' ? 'noopener noreferrer' : undefined"
    :download="isFile ? download : undefined"
  >
    <span v-if="computedSrLabel" class="sr-only">{{ computedSrLabel }}</span>
    <slot>
      {{ computedLabel }}
    </slot>
  </a>
</template>

<style scoped></style>
